const isVisible = (element) => {
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

export default isVisible;
